import type { SVGProps } from 'react';
import * as React from 'react';

const ChannelsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/channels">
      <path
        id="Vector"
        d="M12 1C5.92148 1 1 5.92148 1 12V20.963C1 22.0874 1.91259 23 3.03704 23H12C18.0785 23 23 18.0785 23 12C23 5.92148 18.0704 1 12 1ZM16.0007 16.6363C15.3163 17.0274 14.2081 17.0274 11.9919 17.0274C9.77556 17.0274 8.66741 17.0274 7.98296 16.6363C7.05407 16.1067 6.4837 15.1207 6.49185 14.0452C6.49185 13.263 7.05407 12.3015 8.15407 10.3785C9.26222 8.4637 9.8163 7.50222 10.4926 7.10296C11.4133 6.56519 12.5541 6.56519 13.483 7.10296C14.1593 7.50222 14.7133 8.45556 15.8215 10.3785C16.9296 12.2933 17.4837 13.2548 17.4837 14.0452C17.4837 15.1126 16.9215 16.1067 15.9926 16.6363H16.0007Z"
        fill="#6366F1"
      />
      <path
        id="Vector_2"
        d="M13.703 11.4378C12.9533 10.1422 12.5785 9.49036 12.0163 9.49036C11.4541 9.49036 11.0793 10.1422 10.3296 11.4378L10.1911 11.6822C9.44147 12.9778 9.06666 13.6296 9.3437 14.1185C9.62888 14.6074 10.3785 14.6074 11.8778 14.6074H12.163C13.6622 14.6074 14.4118 14.6074 14.697 14.1185C14.9822 13.6296 14.6074 12.9859 13.8496 11.6822L13.7111 11.4378H13.703Z"
        fill="#4649EB"
      />
      <path
        id="Intersect"
        d="M8.15387 10.3784C7.05387 12.3014 6.49176 13.2632 6.49176 14.0454C6.48369 15.1209 7.05416 16.1066 7.98297 16.6362C8.66741 17.0273 9.77553 17.0278 11.9918 17.0278C14.2079 17.0278 15.3161 17.0273 16.0005 16.6362H15.9927C16.0205 16.6204 16.0467 16.6021 16.0738 16.5854L16.0826 16.5952L9.67731 23.0005H3.03668C1.91254 23.0003 0.999797 22.0875 0.999573 20.9634V17.0444L8.83942 9.20361C8.63488 9.548 8.40883 9.93786 8.15387 10.3784Z"
        fill="#4649EB"
      />
    </g>
  </svg>
);
export default ChannelsIcon;
